import React from "react";
import { useDispatch } from "react-redux";
import Button from "../Common/FormElements/Button/Button";

import DeleteBtn from "../Common/FormElements/DeleteBtn";
import { closeCenteredModal } from "../../REDUX/actions/centeredModal";
import { deleteCommande } from "../../REDUX/actions/commandes";
import { useTranslation } from "react-i18next";

const DeleteCommand = ({
  commandeNumber,
  commandeId,
  searchInput,
  activeTab,
  productsactiveTab,
}) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(
      deleteCommande(commandeId, { searchInput, activeTab, productsactiveTab }),
    );
    dispatch(closeCenteredModal());
  };
  const closeModal = () => {
    dispatch(closeCenteredModal());
  };

  return (
    <div className="d-flex flex-column align-items-center gap-3">
      <p>
        {t("Are you sure you want to delete the order")} #{commandeNumber} ?{" "}
      </p>
      <div className="d-flex gap-3">
        <DeleteBtn onClick={handleDelete} />
        <Button onClick={closeModal}>{t("Cancel")}</Button>
      </div>
    </div>
  );
};

export default DeleteCommand;
